<template>
    <div class="w-100 h-100 sign-in-mobile" v-show="ready">
        <div class="w-100 h-100" v-if="$organization.sso"><i class="el-icon-loading"></i></div>
        <div v-else>
            <page-header></page-header>
        </div>
        <div class="page-body">
            <el-carousel indicator-position="inside" height="493px">
                <el-carousel-item v-for="item in background_images" :key="item">
                    <div class="carousel-image" :style="{'background-image':'url('+item+')'}"></div>
                </el-carousel-item>
            </el-carousel>
            <div class="body-wrap">
                <div class="login page-container">
                    <div class="login-wrap">
                        <div class="login-bg">
                            <div class="login-table">
                                <div class="text-center login-title">
                                    登 录 | SIGN IN
                                </div>
                                <div class="line"></div>
                                <form class="clearfix" action="/" @submit.prevent="submitForm" v-if="admin_login">
                                    <div class="login-group">
                                        <div class="login-icon"><i class="fa fa-envelope"></i> &nbsp;</div>
                                        <div class="login-input-wrap">
                                            <input type="text" v-model="login.id"
                                                   placeholder="用户/邮箱" class="login-input" required>
                                        </div>
                                    </div>

                                    <div class="login-group mt-2">
                                        <div class="login-icon"><i class="fa fa-lock"></i> &nbsp;</div>
                                        <div class="login-input-wrap">
                                            <input type="password" v-model="login.password"
                                                   placeholder="密码" class="login-input" required>
                                        </div>
                                    </div>

                                    <div class="text-right mb-3">
                                        <a href="javascript:void(0);" @click="resetPassword">
                                            <small>忘记或重置密码</small>
                                        </a>
                                    </div>
                                    <div>
                                        <button type="submit" class="login-btn btn btn-block" :disable="process.loading"
                                                style="font-size:20px;">登 录
                                        </button>
                                    </div>

                                    <div class="text-muted mt-2 d-flex justify-content-between align-items-center">
                                        <div class="">
                                            <el-button type="text" @click="admin_login=false" style="padding: 0"
                                                       v-if="oauth">
                                                <img :src="'assets/images/'+$organization.oauth_picture"
                                                     style="height: 48px;" v-if="$organization.oauth_picture">
                                                {{ $organization.oauth_title }}
                                            </el-button>
                                        </div>
                                        <div v-if="oauth"><a href="http://net.sjtu.edu.cn" target="_blank"
                                                             v-if="$organization.helper">
                                            <small> 需要帮助?</small>
                                        </a>
                                        </div>
                                    </div>
                                </form>
                                <div v-if="!admin_login" class="flex-in-middle" style="height: 240px;">
                                    <div class="" style="height: 1px"></div>
                                    <div class="w-100">
                                        <button type="button" class="login-btn btn btn-block" :disable="process.loading"
                                                @click="jumpToOAuth2" style="font-size:20px;">
                                            {{ $organization.oauth_title }}登录
                                        </button>
                                        <div style="font-size:13px;text-align: center;margin-top: 20px;"
                                             class="text-muted">点击按键,跳转到 <b>{{ $organization.oauth_title }}登录</b>
                                        </div>
                                    </div>
                                    <div class="w-100 text-center" >
                                        <el-button type="text" @click="admin_login=true" v-if="should_show_admin">用户口令登录</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-footer">
            <page-footer></page-footer>
        </div>

        <el-dialog append-to-body width="50%" title="错误" :visible.sync="show_login_error"
                   :close-on-click-modal="false" v-mobile-dialog>

            <el-row :gutter="20">
                <el-col :span="24">
                    <div v-html="error_message"></div>
                </el-col>
            </el-row>
            <div slot="footer" class="">
                <el-button type="primary" @click="jumpToSignIn">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PageFooter from "../../components/page-footer";
import PageHeader from "../../components/page-header";
import "@/scss/sign-in.scss";
import SignIn from "@/views/mixins/sign-in"
export default {
    mixins: [SignIn],
    components: {PageHeader, PageFooter},
}
</script>

